import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    step: 1,
    configuration: {
        selectedTarget: null,
        selectedBehavior: null,
        selectedTargetFocus: null,
        buildedTargets: [],
        toEditData: {
            mode: "", // and or,
            data: null
        },
        savantReadMessage: "",
        savantReadIsInitial: true
    },
    behaviorTreeData: []
};

const marketExplorer = createSlice({
    name: "marketExplorer",
    initialState: { ...initialState },
    reducers: {
        setStep: (state, action) => ({ ...state, step: action.payload }),
        setConfigSelectedTarget: (state, action) => {
            state.configuration.selectedTarget = action.payload;
        },
        setConfigSelectedBehavior: (state, action) => {
            state.configuration.selectedBehavior = action.payload;
        },
        setConfigSelectedTargetFocus: (state, action) => {
            state.configuration.selectedTargetFocus = action.payload;
        },
        setToEditData: (state, action) => {
            state.configuration.toEditData = action.payload;
            state.configuration.savantReadIsInitial = true;
        },
        setBehaviorTreeData: (state, action) => {
            state.behaviorTreeData = action.payload;
        },
        setSavantReadMessage: (state, action) => {
            state.configuration.savantReadMessage = action.payload;
        },
        setSavantReadIsInitial: (state, action) => {
            state.configuration.savantReadIsInitial = action.payload;
        },
        addBuildTarget: (state, action) => {
            state.configuration.buildedTargets.push(action.payload);
        },
        removeBuildTarget: (state, action) => {
            const index = state.configuration.buildedTargets.findIndex((item) => item.key === action.payload.key);
            state.configuration.buildedTargets.splice(index, 1);
        },
        removeAllBuildTarget: (state, action) => {
            state.configuration.buildedTargets = []
        },
        updateBuildTargetItemName: (state, action) => {
            const itemTarget = state.configuration.buildedTargets.find((item) => (item.key === action.payload.key));
            itemTarget.name = action.payload.name;
        },
        updateBuildItemTargets: (state, action) => {
            const { audienceId, groupIndex, targets } = action.payload;
            const audience = state.configuration.buildedTargets.find((item) => (item.key === audienceId));
            const group = audience.groups.find((item, idx) => (idx === groupIndex));
            group.targets = targets;
        },
        addBuildTargetGroup: (state, action) => {
            const { audienceId } = action.payload;
            const audience = state.configuration.buildedTargets.find((item) => (item.key === audienceId));
            const newObj = { ...action.payload };
            delete newObj.groupIndex;
            delete newObj.audienceId;
            audience.groups.push(newObj);
        },
        removeBuildTargetGroup: (state, action) => {
            const { audienceId, groupIndex } = action.payload;
            const audience = state.configuration.buildedTargets.find((item) => item.key === audienceId);
            audience.groups.splice(groupIndex, 1);
            if (!audience.groups.length) {
                const audienceIndex = state.configuration.buildedTargets.findIndex((item) => item.key === audienceId);
                state.configuration.buildedTargets.splice(audienceIndex, 1);
            }
        },
        resetAllMarketExplorerConfig: (state) => {
            const newState = { ...initialState };
            Object.keys(newState).forEach((key) => {
                state[key] = newState[key];
            });
        },
        setMarketExplorerFromLoadedJson: (state, action) => {
            Object.keys(action.payload).forEach((key) => {
                state[key] = action.payload[key];
            });
        }
    }
});

const { reducer, actions } = marketExplorer;
export const {
    setConfigSelectedTarget, setConfigSelectedBehavior, addBuildTarget, removeBuildTarget, removeAllBuildTarget,
    setToEditData, updateBuildTargetItemName, updateBuildItemTargets, setStep, addBuildTargetGroup, setSavantReadMessage,
    removeBuildTargetGroup, setSavantReadIsInitial, setBehaviorTreeData, resetAllMarketExplorerConfig, setConfigSelectedTargetFocus,
    setMarketExplorerFromLoadedJson
} = actions;
export default reducer;
